module.exports = __webpack_public_path__ + "static/media/clock.ee0e29c1.png";